import { create } from 'zustand'

interface WebviewHistoryState {
  fromApp: boolean
  depth: number
}

interface NavigationState {
  depth: number
  initialized: boolean
  init: () => void
  canGoBack: () => boolean
  incrementDepth: () => number
  decrementDepth: () => number
  setDepth: (depth: number) => void
  reset: () => void
}

const getHistoryState = (): WebviewHistoryState | null => {
  if (typeof window === 'undefined') {
    return null
  }

  const state = window.history.state

  if (state && typeof state === 'object' && state.fromApp === true && typeof state.depth === 'number') {
    return state as WebviewHistoryState
  }

  return null
}

const saveDepthToHistory = (depth: number) => {
  if (typeof window === 'undefined') {
    return
  }

  window.history.replaceState(
    {
      ...window.history.state,
      fromApp: true,
      depth
    },
    ''
  )
}

export const useNavigationStore = create<NavigationState>((set, get) => ({
  depth: 0,
  initialized: false,

  init: () => {
    const historyState = getHistoryState()

    if (historyState) {
      // history.state에 저장된 depth가 있으면 복원이 필요..!
      set({ depth: historyState.depth, initialized: true })
    } else {
      set({ depth: 0, initialized: true })
      saveDepthToHistory(0)
    }
  },

  canGoBack: () => {
    if (!get().initialized) {
      const historyState = getHistoryState()

      return historyState ? historyState.depth > 0 : false
    }

    return get().depth > 0
  },

  incrementDepth: () => {
    const newDepth = get().depth + 1
    set({ depth: newDepth })

    return newDepth
  },

  decrementDepth: () => {
    const newDepth = Math.max(0, get().depth - 1)
    set({ depth: newDepth })

    return newDepth
  },

  setDepth: (depth: number) => {
    set({ depth: Math.max(0, depth) })
  },

  // 필요의 경우 사용
  reset: () => {
    set({ depth: 0, initialized: false })
  }
}))

export { saveDepthToHistory }
